import { render, staticRenderFns } from "./scorecheckManage.vue?vue&type=template&id=738b153c&"
import script from "./scorecheckManage.vue?vue&type=script&lang=js&"
export * from "./scorecheckManage.vue?vue&type=script&lang=js&"
import style0 from "./scorecheckManage.vue?vue&type=style&index=0&id=738b153c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports